<style scoped>
    .profile-health-component {
        position: relative;
        width: 350px;
        flex-grow: 1;
        overflow-x: auto;
        overflow-y: scroll;
    }

    .profile-health-component .spinner.visible {
        display: block;
        background-color: #FFFc;
    }

    .profile-health-component .fa-icon {
        vertical-align: middle;
    }

    .health-check-result-group-name.clickable {
        cursor: pointer;
    }

    .collapse-group-icon {
        color: #888;
    }

    .health-check-result-groups,
    .health-check-results {
        list-style: none;
        padding-left: 24px;
        margin-top: 0;
        margin-bottom: 14px;
    }

    .health-check-result-group-description,
    .health-check-result-description {
        font-size: 90%;
        color: #888;
        line-height: 1.2em;
        margin-left: 18px;
        margin-bottom: 4px;
    }

</style>
<template>
    <div class="profile-health-component">
        <ul class="health-check-result-groups">
            <li v-for="healthCheckResultGroup in healthCheckResultGroups">
                <div>
                    <health-status-indicator :status-value="healthCheckResultGroup.Status"></health-status-indicator>
                    <span class="health-check-result-group-name" :class="{'clickable':areHealthCheckResultsAvailableInGroup(healthCheckResultGroup)}"
                          @click="toggleCollapse(healthCheckResultGroup)">
                        {{healthCheckResultGroup.Name}} {{ healthCheckResultGroup.Miliseconds ? `(${healthCheckResultGroup.Miliseconds}ms)` : '' }}
                        <template v-if="areHealthCheckResultsAvailableInGroup(healthCheckResultGroup)">
                            <icon v-if="healthCheckResultGroup.isCollapsed" name="caret-right" class="collapse-group-icon"></icon>
                            <icon v-else name="caret-down" class="collapse-group-icon"></icon>
                        </template>
                    </span>
                    <div v-if="healthCheckResultGroup.Message" class="health-check-result-group-description">{{healthCheckResultGroup.Message}}</div>
                </div>
                <ul v-if="areHealthCheckResultsAvailableInGroup(healthCheckResultGroup)" v-show="!healthCheckResultGroup.isCollapsed" class="health-check-results">
                    <li v-for="checkResult in healthCheckResultGroup.CheckResults">
                        <health-status-indicator :status-value="checkResult.Status"></health-status-indicator>
                        <span>
                            {{checkResult.Name}}
                        </span>
                        <div v-if="checkResult.Message" class="health-check-result-description">{{checkResult.Message}}</div>
                    </li>
                </ul>
            </li>
        </ul>
        <div v-if="isLoading" class="spinner" :class="{'visible':isLoading}"></div>
    </div>
</template>
<script>
    import axios from 'axios';
    import qs from 'qs';
    import HealthStatusIndicator from './HealthStatusIndicator';
    import Vue from 'vue';
    import { mapGetters } from 'vuex';
    import { NAMESPACE as APP_NAMESPACE } from '../store/modules/app.js';
    import 'vue-awesome/icons/caret-down';
    import 'vue-awesome/icons/caret-right';
    import Icon from 'vue-awesome/components/Icon.vue';

    const STATUS_NOT_TESTED = 0;
    const STATUS_OK = 1;
    const STATUS_WARNING = 2;
    const STATUS_ERROR = 3;

    export default {
        props: [
            'profileGuid'
        ],

        data() {
            return {
                healthCheckResultGroups: [],
                isProfileHealthResultLoading: false
            }
        },

        computed: {
            ...mapGetters({
                contextPath: APP_NAMESPACE.getters.CONTEXT_PATH
            }),
            isLoading() {
                return this.isProfileHealthResultLoading;
            },
            backendUrl() {
                return  (this.profileGuid)
                    ? this.contextPath + "/profiles/" + this.profileGuid + "/HealthCheck"
                    : this.contextPath + "/profiles/HealthCheck";
            }
        },

        components: {
            'health-status-indicator': HealthStatusIndicator,
            'icon': Icon
        },

        methods: {
            loadProfileHealth(profileDataToOverride) {
                this.isProfileHealthResultLoading = true;
                let dataString = qs.stringify(profileDataToOverride);
                return axios.post(this.backendUrl, dataString)
                    .then(this.handleResponseData)
                    .catch(this.handleResponseError)
                    .then(() => { //always
                        this.isProfileHealthResultLoading = false;
                    });
            },
            refresh(profileDataToOverride) {
                this.loadProfileHealth(profileDataToOverride);
            },
            toggleCollapse(healthCheckResultGroup) {
                healthCheckResultGroup.isCollapsed = !healthCheckResultGroup.isCollapsed;
            },
            areHealthCheckResultsAvailableInGroup(healthCheckResultGroup) {
                return healthCheckResultGroup.CheckResults && healthCheckResultGroup.CheckResults.length;
            },
            handleResponseData(response) {
                this.healthCheckResultGroups = response.data;
                this.healthCheckResultGroups.forEach((healthCheckResultGroup) => {
                    const shouldBeCollapsed = healthCheckResultGroup.Status <= STATUS_OK;
                    Vue.set(healthCheckResultGroup, 'isCollapsed', shouldBeCollapsed);
                });
            },
            handleResponseError(error) {
                const errorMessagePrefix = "Error getting profile health result";
                console.log(errorMessagePrefix + " : ", error);
                this.healthCheckResultGroups = [{
                    'Name': errorMessagePrefix,
                    'Status': STATUS_ERROR,
                    'Message': error.message
                }];
            }
        },
        mounted() {
            this.loadProfileHealth();
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/ProfileHealth.vue